import {
  CopyLinkLanguage,
  isCopyLinkLanguage,
} from "@/const/copyLinkTranslations";

export type OpenInBrowserCopy = {
  blocked: string;
  instruction: string;
};

// Always the App Store: this only ever reaches an iOS webview.
export const OPEN_IN_BROWSER_TRANSLATIONS: Record<
  CopyLinkLanguage,
  OpenInBrowserCopy
> = {
  en: {
    blocked: "If the App Store didn't open, this app is blocking it.",
    instruction:
      "Tap ••• in the top right, then open this page in your browser.",
  },
  pl: {
    blocked: "Jeśli App Store się nie otworzył, blokuje go ta aplikacja.",
    instruction:
      "Dotknij ••• w prawym górnym rogu i otwórz tę stronę w przeglądarce.",
  },
  es: {
    blocked: "Si la App Store no se abrió, esta aplicación la está bloqueando.",
    instruction:
      "Toca ••• arriba a la derecha y abre esta página en tu navegador.",
  },
  fr: {
    blocked: "Si l'App Store ne s'est pas ouvert, cette application le bloque.",
    instruction:
      "Appuyez sur ••• en haut à droite, puis ouvrez cette page dans votre navigateur.",
  },
  de: {
    blocked: "Wenn der App Store nicht aufging, blockiert diese App ihn.",
    instruction:
      "Tippe oben rechts auf ••• und öffne diese Seite in deinem Browser.",
  },
  it: {
    blocked: "Se l'App Store non si è aperto, questa app lo sta bloccando.",
    instruction:
      "Tocca ••• in alto a destra e apri questa pagina nel tuo browser.",
  },
  pt: {
    blocked: "Se a App Store não abriu, este aplicativo está bloqueando.",
    instruction:
      "Toque em ••• no canto superior direito e abra esta página no seu navegador.",
  },
  nl: {
    blocked: "Als de App Store niet openging, blokkeert deze app dat.",
    instruction: "Tik rechtsboven op ••• en open deze pagina in je browser.",
  },
  ja: {
    blocked: "App Store が開かない場合は、このアプリがブロックしています。",
    instruction:
      "右上の ••• をタップして、このページをブラウザで開いてください。",
  },
  ko: {
    blocked: "App Store가 열리지 않으면 이 앱이 차단하고 있습니다.",
    instruction: "오른쪽 위 •••을 눌러 이 페이지를 브라우저에서 열어 주세요.",
  },
  zh: {
    blocked: "如果 App Store 没有打开，是这个应用拦截了它。",
    instruction: "点按右上角的 •••，然后在浏览器中打开此页面。",
  },
};

/**
 * Takes a full browser tag such as "pt-BR" and falls back to English for
 * anything we have no wording for.
 */
export function getOpenInBrowserCopy(
  language: string | null | undefined
): OpenInBrowserCopy {
  const base = language?.split("-")[0].toLowerCase();

  if (isCopyLinkLanguage(base)) return OPEN_IN_BROWSER_TRANSLATIONS[base];
  return OPEN_IN_BROWSER_TRANSLATIONS.en;
}
